import { classNames } from '@dimjs/utils';
import { CSSProperties, ReactElement } from 'react';
import './style.less';

export interface EmptyProps {
  text?: string | ReactElement;
  desc?: string;
  button?: string | ReactElement;
  className?: string;
  style?: CSSProperties;
  isShow: boolean;
}

export const Empty = (props: EmptyProps) => {
  if (!props.isShow) return null;
  return (
    <div className={classNames('v-empty', props.className)} style={props.style}>
      <div className="v-empty-icon"></div>
      <div className="v-empty-text">{props.text}</div>
      {props.desc ? <div className="v-empty-desc">{props.desc}</div> : null}
      {props.button && <div className="v-empty-button">{props.button}</div>}
    </div>
  );
};
